<template>
  <div class="flex flex-col gap-12">
    <ArticleContent title="Nossa essência" alignment="left">
      <p>
        A <strong>Trimboli</strong> é uma empresa especializada em soluções de
        securitização, locação e administração de imóveis, comprometida em
        oferecer serviços de alta qualidade e confiança. Com uma trajetória
        marcada pela dedicação e seriedade, buscamos sempre entregar resultados
        que excedem as expectativas dos nossos clientes. Nossa atuação é pautada
        pela transparência e pela eficiência, proporcionando segurança e
        tranquilidade em cada etapa dos processos que conduzimos.
      </p>
    </ArticleContent>

    <ArticleContent title="Inovação e qualificação" alignment="right">
      <p>
        Com uma equipe de profissionais altamente qualificados e uma
        infraestrutura robusta, a Trimboli se destaca no mercado por sua
        capacidade de adaptação e inovação. Trabalhamos continuamente para
        aprimorar nossas práticas, incorporando as mais recentes tecnologias e
        metodologias para garantir que nossos clientes recebam o melhor suporte
        possível. Nosso foco é criar valor duradouro, seja na gestão de ativos
        imobiliários ou na securitização de recebíveis, sempre com um olhar
        atento às necessidades e objetivos específicos de cada cliente.
      </p>
    </ArticleContent>

    <ArticleContent title="Compromisso com a excelência" alignment="left">
      <p>
        Acreditamos que nosso sucesso está diretamente ligado ao sucesso de
        nossos clientes. Por isso, nos dedicamos a entender profundamente suas
        necessidades, oferecendo soluções personalizadas que atendem às demandas
        mais complexas com agilidade e precisão. Na Trimboli, nosso compromisso
        é com a excelência, e estamos prontos para construir, junto com nossos
        clientes, um futuro sólido e promissor.
      </p>
    </ArticleContent>
  </div>
</template>

<script>
import ArticleContent from "@/components/common/ArticleContent.vue";

export default {
  name: "AboutArticles",
  components: { ArticleContent },
};
</script>
